import { gql } from 'urql';

const FetchCardCvv = gql`
  query FetchCardCvv($input: CardNumberInput!, $includeCvv: Boolean!) {
    cardNumber(input: $input) {
      __typename
      ... on CardNumberSuccess {
        pan
        expiration
        cvv2 @include(if: $includeCvv)
      }
      ... on CardNumberChallenge {
        challenges {
          challengeId
          challengeType
          challengeContext
          challengeState
          expiresAt
        }
      }
      ... on CardNumberDecline {
        code
        title
        message
      }
    }
  }
`;

export default FetchCardCvv;
